/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B2_DInputs */

const en_mk_abt_b2_d = /** @type {(inputs: Mk_Abt_B2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The moment a product demands an install, it stops being usable by finance and operations. Everything here runs on the server.`)
};

const id_mk_abt_b2_d = /** @type {(inputs: Mk_Abt_B2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begitu sebuah produk menuntut pemasangan di komputer, ia berhenti bisa dipakai oleh bagian keuangan dan operasional. Semua di sini berjalan di server.`)
};

/**
* | output |
* | --- |
* | "The moment a product demands an install, it stops being usable by finance and operations. Everything here runs on the server." |
*
* @param {Mk_Abt_B2_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b2_d = /** @type {((inputs?: Mk_Abt_B2_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B2_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b2_d(inputs)
	return en_mk_abt_b2_d(inputs)
});